import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/views/approval/config/style/index.scss';
import { getLanguage, saveLanguage } from 'api/flow';
import { langList } from '@/lang';
export default {
  data: function data() {
    return {
      // 是否编辑状态
      isEdit: false,
      // 表格数据
      tableData: [],
      // 是否展示表格
      isViewTable: true,
      // 存储loading
      saveload: false,
      form: {
        flowId: '',
        defaultLang: 'zh'
      }
    };
  },
  created: function created() {
    // 获取审批流ID 无则返回上一页
    try {
      this.form.flowId = this.$route.query.id;
    } catch (error) {
      this.$router.go(-1);
    }
    this.getLang();
  },
  computed: {
    // 默认系统语言排序最前
    sortlang: function sortlang() {
      var _this = this;
      var item;
      var list = _toConsumableArray(langList);
      list.splice(list.length - 1, 1);
      list.forEach(function (element, index) {
        if (element.key === _this.form.defaultLang) item = list.splice(index, 1);
      });
      list.unshift(item[0]);
      return list;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 切换语言 更新排序必填校验
    handleChange: function handleChange() {
      var _this2 = this;
      this.isViewTable = false;
      this.$nextTick(function () {
        return _this2.isViewTable = true;
      });
    },
    // 初始化获取数据
    getLang: function getLang() {
      var _this3 = this;
      getLanguage(this.form).then(function (res) {
        var _res$data = res.data,
          preferredLanguage = _res$data.preferredLanguage,
          items = _res$data.items;
        _this3.form.defaultLang = preferredLanguage;
        _this3.tableData = items;
        _this3.handleChange();
      });
    },
    // 编辑or取消编辑
    handleChangeEdit: function handleChangeEdit() {
      this.isEdit = !this.isEdit;
      this.getLang();
    },
    // 保存
    handleSave: function handleSave() {
      var _this4 = this;
      // 表单表格校验
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.saveload = false;
          saveLanguage({
            preferredLanguage: _this4.form.defaultLang,
            flowId: _this4.form.flowId,
            modifyData: JSON.stringify(_this4.tableData)
          }).then(function (res) {
            _this4.getLang();
            _this4.isEdit = false;
          }).finally(function () {
            _this4.saveload = false;
          });
        }
      });
    }
  }
};